// extracted by mini-css-extract-plugin
module.exports = {"container":"image-modal__container___1xzqf","left":"image-modal__left___1cABp","right":"image-modal__right___3EMsH"};